import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { eventQBus } from "../../types/EventQBus";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export class TopicPageFilterHandler {
  private readonly originalSelektion: string | null;

  constructor() {
    this.originalSelektion = new URLSearchParams(window.location.search).get("selektion");
  }

  init(): void {
    eventQBus.on("ftfind.dresonRule.resolved", (event: DresonRuleResolvedEvent) => this.onResolved(event));
  }

  isTopicPage(): boolean {
    return document.documentElement.dataset.pagecluster === "Themenseite";
  }

  onResolved(event: DresonRuleResolvedEvent): void {
    if (!this.isTopicPage()) {
      return;
    }
    const url = this.buildUrl(event.rule);
    eventQBus.emit("ftfind.history.push", { url });
  }

  buildUrl(resolvedRule: string): string {
    const search = window.location.search;
    const isFiltered = resolvedRule !== this.originalSelektion;
    const filteredParam = `filtered=${encodeURIComponent(resolvedRule)}`;

    /**
 *
 *
 *
 *
 *
 */
    const withoutFiltered = search.replace(/([?&])filtered=[^&]*(&|$)/, (_, prefix, suffix) =>
      suffix ? prefix : "",
    );
    const separator = withoutFiltered.includes("?") ? "&" : "?";
    const newSearch = isFiltered ? withoutFiltered + separator + filteredParam : withoutFiltered;
    return window.location.pathname + newSearch;
  }
}
